import { NextSeo } from 'next-seo';
import dynamic from 'next/dynamic';
import React from 'react';
import { config } from '../../config';

const Providers = dynamic(() => import('../../components/Providers'), {
  ssr: false,
});

const GekoPage = dynamic(() => import('../../components/GekoPage'), {
  ssr: false,
});

function gekoPage() {
  const title = 'Geko 1/1';
  const description = `A collection of 625 hand-drawn NFTs on the Algorand blockchain. All Gekos are 100% unique and totally exclusive.`;

  return (
    <>
      <NextSeo title={`${title} - ${config.siteName}`} description={description} />

      <Providers>
        <GekoPage />
      </Providers>
    </>
  );
}

export default gekoPage;
